import http from 'conversations-http/clients/http';
const CONNECTED_ACCOUNTS_PREFIX = 'conversations-email/v1/connected-accounts';
export const getConnectedEmailAccount = async ({
  id
}) => await http.get(`${CONNECTED_ACCOUNTS_PREFIX}/${id}`);
export const getConnectedEmailAccounts = async () => await http.get(`${CONNECTED_ACCOUNTS_PREFIX}/all`);
export const getConnectedEmailAccountByChannelInstanceId = async ({
  channelInstanceId
}) => await http.get(`${CONNECTED_ACCOUNTS_PREFIX}/channel-instance/${channelInstanceId}/non-deleted`);